import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export enum AbStep {
    USER_WHITELISTED = 0,
    USER_GROUP_WHITELISTED = 1,
    FILTER_CONDITIONS = 2,
    SLICE_RANGE = 3,
    TRAFFIC_ALLOCATED = 4,
    UNRECOGNIZED = -1
}
export enum CofStep {
    VALIDATE_REQUEST = 0,
    REQUEST_ATLAS = 1,
    BUILD_TARGETING_INFO = 2,
    QUERY_INDEX = 3,
    REQUEST_AB = 4,
    UNRECOGNIZED = -1
}
export interface AbStepInfo {
    abStep: AbStep;
    info: string;
}
export interface CofStepInfo {
    cofStep: CofStep;
    info: string;
}
export interface DebugTrace {
    lastCofStep: CofStepInfo | undefined;
    lastAbStep: AbStepInfo | undefined;
    budgetGroupId: number;
}
function createBaseAbStepInfo(): AbStepInfo {
    return { abStep: 0, info: "" };
}
export const AbStepInfo: MessageFns<AbStepInfo> = {
    encode(message: AbStepInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.abStep !== 0) {
            writer.uint32(8).int32(message.abStep);
        }
        if (message.info !== "") {
            writer.uint32(18).string(message.info);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): AbStepInfo {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAbStepInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.abStep = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.info = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<AbStepInfo>, I>>(base?: I): AbStepInfo {
        return AbStepInfo.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<AbStepInfo>, I>>(object: I): AbStepInfo {
        const message = createBaseAbStepInfo();
        message.abStep = object.abStep ?? 0;
        message.info = object.info ?? "";
        return message;
    },
};
function createBaseCofStepInfo(): CofStepInfo {
    return { cofStep: 0, info: "" };
}
export const CofStepInfo: MessageFns<CofStepInfo> = {
    encode(message: CofStepInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.cofStep !== 0) {
            writer.uint32(8).int32(message.cofStep);
        }
        if (message.info !== "") {
            writer.uint32(18).string(message.info);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): CofStepInfo {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCofStepInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.cofStep = reader.int32() as any;
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.info = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<CofStepInfo>, I>>(base?: I): CofStepInfo {
        return CofStepInfo.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CofStepInfo>, I>>(object: I): CofStepInfo {
        const message = createBaseCofStepInfo();
        message.cofStep = object.cofStep ?? 0;
        message.info = object.info ?? "";
        return message;
    },
};
function createBaseDebugTrace(): DebugTrace {
    return { lastCofStep: undefined, lastAbStep: undefined, budgetGroupId: 0 };
}
export const DebugTrace: MessageFns<DebugTrace> = {
    encode(message: DebugTrace, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.lastCofStep !== undefined) {
            CofStepInfo.encode(message.lastCofStep, writer.uint32(10).fork()).join();
        }
        if (message.lastAbStep !== undefined) {
            AbStepInfo.encode(message.lastAbStep, writer.uint32(18).fork()).join();
        }
        if (message.budgetGroupId !== 0) {
            writer.uint32(24).uint32(message.budgetGroupId);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): DebugTrace {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDebugTrace();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.lastCofStep = CofStepInfo.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.lastAbStep = AbStepInfo.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.budgetGroupId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<DebugTrace>, I>>(base?: I): DebugTrace {
        return DebugTrace.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<DebugTrace>, I>>(object: I): DebugTrace {
        const message = createBaseDebugTrace();
        message.lastCofStep = (object.lastCofStep !== undefined && object.lastCofStep !== null)
            ? CofStepInfo.fromPartial(object.lastCofStep)
            : undefined;
        message.lastAbStep = (object.lastAbStep !== undefined && object.lastAbStep !== null)
            ? AbStepInfo.fromPartial(object.lastAbStep)
            : undefined;
        message.budgetGroupId = object.budgetGroupId ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
